import { createFileRoute, redirect } from "@tanstack/react-router";
import { LeadsTableEnhanced } from "@/app/partner/pages/leads/LeadsTableEnhanced";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/leads/")({
	validateSearch: (
		search: Record<string, unknown>,
	): { action?: string; search_query?: string } => ({
		action: typeof search.action === "string" ? search.action : undefined,
		// Seeds the leads search (name or city), e.g. from a dashboard city panel.
		search_query:
			typeof search.search_query === "string" && search.search_query.trim()
				? search.search_query.trim().slice(0, 100)
				: undefined,
	}),
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "leads");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: LeadsTableEnhanced,
});
